import { render, staticRenderFns } from "./ScoutingReportMatrixV3.vue?vue&type=template&id=9379ad84&scoped=true&"
import script from "./ScoutingReportMatrixV3.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportMatrixV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9379ad84",
  null
  
)

export default component.exports